import {isNil} from "lodash";

export const ajaxTableMixin = {
    data() {
        return {
            ajaxTable: {
                // For the table's loading state.
                loading: false,

                requestNumber: 0,

                // Search
                search: '',

                // Filter
                sortBy: '',
                sortDesc: false,

                // Paging properties
                page: 1,
                itemsPerPage: "100",
                pageInfo: {
                    pages: 1,
                    from: 1,
                    to: 1,
                    total: 1
                }
            },
        }
    },
    mounted() {

    },
    methods: {
        ajaxUpdateTableData(data) {
            let meta = data.meta
            let metaFound = ! _.isNil(meta)

            this.ajaxTable.pageInfo = {
                current_page: metaFound ? meta.current_page : null,
                last_page: metaFound ? meta.last_page : null,
                path: metaFound ? meta.path : null,
                per_page: metaFound ? meta.per_page : null,

                // Data defined for first Load
                pages: metaFound ? meta.last_page : 1,
                from: metaFound ? meta.from : 0,
                to: metaFound ? meta.to : 0,
                total: metaFound ? meta.total : 0,

                // Request number to ensure data is most recent
                requestNumber: metaFound ? meta.requestNumber : null,
            }

            if (this.ajaxTable.page > this.ajaxTable.pageInfo.pages) {
                this.ajaxTable.page = this.ajaxTable.pageInfo.pages
            }
        },
    },
    computed: {

    },
}
